import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { RichTextArea } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { useIntl, useSelector, statusSuccess } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../../../../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../../../../../state/state/actions.js";
import "../../../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../../../state/bundles/state/bundles/reducer.js";
import { getPrescription } from "../../../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../../../state/products/state/products/selectors.js";
import "../../../../../../../../state/products/state/products/reducer.js";
import { PrescriptionInformationDrawer } from "../../../../../../../components/PrescriptionInformationDrawer/steps/components/PrescriptionInformationDrawer/PrescriptionInformationDrawer.js";
import "classnames";
/* empty css                                                                                                                                        */
/* empty css                                                                                                                                                                           */
import { PrescriptionFormLabelDetailsTrigger } from "../../../../components/steps/PrescriptionFormStep/components/PrescriptionFormLabelDetails/components/PrescriptionFormLabelDetailsTrigger.js";
/* empty css                                  */
const PrescriptionFormLabelDetails = () => {
  const { getLabel } = useIntl();
  const { configuratorDocument } = useRxGlassesConfiguratorContext();
  const title = getLabel("products.configurator.step.prescription.opticalparams.details");
  const richTextDescription = configuratorDocument?.prescriptionStep?.readDescription;
  const prescription = useSelector(getPrescription);
  if (!statusSuccess(prescription)) {
    return null;
  }
  const opticalParameters = prescription.result.parameters;
  const handleClick = () => {
    DataLayer.Events.pushDrawerEventToDataLayer({
      siteFeature: "rxconfigurator",
      interactionType: "how_to_read_prescription_click"
    });
  };
  return /* @__PURE__ */ React.createElement(
    PrescriptionInformationDrawer,
    {
      trigger: /* @__PURE__ */ React.createElement(PrescriptionFormLabelDetailsTrigger, { onClick: handleClick, title }),
      title,
      "data-t": "prescription-form-drawer"
    },
    richTextDescription ? /* @__PURE__ */ React.createElement(RichTextArea, { content: richTextDescription, isContained: true }) : /* @__PURE__ */ React.createElement("div", { className: "prescription-form-label-details" }, /* @__PURE__ */ React.createElement("dl", { "aria-label": title, className: "prescription-form-label-details__list" }, opticalParameters.map((item, index) => {
      return /* @__PURE__ */ React.createElement("div", { className: "prescription-form-label-details__item", key: index }, /* @__PURE__ */ React.createElement("dt", null, /* @__PURE__ */ React.createElement(
        Heading,
        {
          component: "h4",
          variant: "subheading1",
          className: "prescription-form-label-details__item--label"
        },
        getLabel(`products.glasses.prescription.${item.name}`)
      )), /* @__PURE__ */ React.createElement("dd", { className: "prescription-form-label-details__item--text" }, getLabel(`products.glasses.prescription.${item.name}.tooltip`)));
    })))
  );
};
export {
  PrescriptionFormLabelDetails
};
//# sourceMappingURL=PrescriptionFormLabelDetails.js.map
